<script>
import { eventBus } from 'src/features';
import { cloneDeep } from 'lodash';

export default {
  props: ['value'],
  data() {
    return {
      skills: [],
      MIN_COUNT: 1,
      MAX_COUNT: 100,
    };
  },
  mounted() {
    this.skills = cloneDeep(this.value.skills);
  },
  methods: {
    save() {
      eventBus.$emit('onSetSkillsPriorities', this.skills);
      this.close();
    },
    close() {
      this.$parent.close([null]);
    },
    rangeColor(isSkillActive) {
      if (!isSkillActive) {
        return '#8f9194';
      } return '#000000de';
    },
  },
};
</script>

<template lang="pug">
div(:class="$style.root")
  header(:class="$style.header")
    div(:class="$style.headerTitle") {{ $t('T_SET_PRIORITIES') }}
  div(:class="$style.content")
    div(:class="$style.contentTitle") {{ $t('T_SKILL') }}
    div(:class="$style.contentTitle") {{ $t('T_PRIORITY') }}
    div(v-for="skill in skills", :class="[$style.skill, !skill.requestType.active && $style.disabled]")
      div(:class="$style.skillLabelWrap")
        div(:class="$style.skillLabel") {{ skill.requestType.name }}
      div
        div(:class="$style.visibilityIconWrap")
          ui-icon(:class="[$style.visibilityIcon, $style.disabled]",
            v-show="!skill.requestType.active") visibility_off
        div(:class="$style.visibilityIconWrap")
          ui-icon(:class="$style.visibilityIcon",
            v-show="skill.requestType.active") visibility
      div(:class="$style.priorityLevel")
        ui-range(v-model="skill.priority", :min="MIN_COUNT", :max="MAX_COUNT" :color="rangeColor(skill.requestType.active)")
      ui-input-number(
        :class="[$style.priorityCount, !skill.requestType.active && $style.disabled]",
        :value="skill.priority",
        :min="MIN_COUNT",
        :max="MAX_COUNT",
        v-model="skill.priority",
        :zero="false")
  footer(:class="$style.footer")
    ui-button(@click.native="close()", @keyup.enter.native="close()") {{ $t('T_CANCEL') }}
    ui-button(:class="$style.save", @click.native="save",
      @keyup.enter.native="save") {{ $t('T_SAVE') }}
</template>

<style lang="sass" module>
.root
  display: block
  max-height: 90vh
.header
  padding: 24px
  border-bottom: 1px solid $color_divider
  &Title
    font-size: 18px
    display: flex
    justify-content: center
.footer
  padding: 24px
  text-align: right
  border-top: 1px solid $color_divider
.content
  padding: 30px 20px 25px 50px
  min-width: 532px
  &Title
    font-size: $title_size
    font-weight: 400
    text-transform: uppercase
    white-space: nowrap
    line-height: $title_size
    height: $title_size
    box-sizing: unset
    transition: color $a_speed, border-color $a_speed
    border-color: $color_main
    display: inline-block
    width: 275px
    padding-bottom: 16px
    & + &
      width: 250px
      margin-right: 0
.skill
  display: flex
  flex-shrink: 0
  align-items: center
  line-height: 18px
  transition: color $a_speed
  & + &
    margin-top: 16px
  &Label
    width: 168px
    overflow: hidden
    text-overflow: ellipsis
    font-size: 14px
    margin-right: 24px
    &.disabled
      color: $color_text_second
    &Wrap
      display: flex
      align-items: center
.priorityCount
  margin-left: 25px
  font-size: 16px
  vertical-align: baseline
  white-space: nowrap
  width: 50px
  padding: 0
  display: block
  border-width: 0 !important
.priorityLevel
  width: 248px
  display: flex
  flex-direction: column
  align-items: stretch
  .channels
    padding: 0
    color: $s_color_main !important
.save
  color: $color_main !important
.visibilityIcon
  width: 24px
  height: 24px
  &Wrap
    width: 24px
    margin: 0 30px
.disabled
  color: $color_text_second !important
</style>
